import { useState, useEffect, useLayoutEffect } from "react";
import { useSearchParams } from "react-router-dom";
import useFetch from "../../utils/useFetch";
import TickRoundIcon from "../../icons/TickRoundIcon";
import HourglassIcon from "../../icons/HourglassIcon";
import TriangleExclamationIcon from "../../icons/TriangleExclamationIcon";
import CollectionsTemplate from "../../components/CollectionsTemplate";

import VendorListItem from "./VendorListItem";
import VendorGridItem from "./VendorGridItem";
import VendorSearchTitleBarChildren from "./VendorSearchTitleBarChildren";
import VendorFilters from "../../pages/VendorSearch/VendorFilters";
import VendorCollectionControls from "./VendorCollectionControls";
import { getOrgType } from "../../utils/Token";

const pageSize = 12;
const queryUrl = "/Vendor/GetVendorSearch";
const filterOptionsUrl = "/Vendor/GetFiltersInVendorSearch";
const miscFilterOptionsUrl = "/Vendor/GetVendorSearchPageLoad";
const allClientsUrl = "/Prequalification/GetAllClients?getAll=false";

function vendorDataAdaptor(data) {
  return {
    // headers: [
    //   { id: "vendorName", text: "Vendor Name" },
    //   { id: "status", text: "Status" },
    //   { id: "statusPeriod", text: "Status Period" },
    //   { id: "analytics", text: "" },
    //   { id: "icon", text: "" },
    // ],
    headers: [
      { id: "vendorName", text: "Vendor Name" },
      { id: "status", text: "Status" },
      { id: "statusPeriod", text: "Status Period" },

      ...(getOrgType() !== "Client"
        ? [{ id: "analytics", text: "" }]
        : []),

      { id: "icon", text: "" },
    ],
    isEditable: {
      callback: (item) => {
        console.log(item);
      },
      isVisible: true,
    },
    isDeletable: {
      callback: (item) => {
        console.log(item);
      },
      isVisible: true,
    },
    rows: data?.data?.map((d) =>
      Object.assign({}, d, {
        key: d.vendorId,
        href: `/${d.vendorId}`,
        statusPeriod: `${d.prequalificationStart || ""} - ${d.prequalificationFinish || ""}`,
        Status: d.status
      })
    ),
    statusRoleMap: {
      prequalified: {
        text: "Prequalified",
        role: "success",
        icon: TickRoundIcon,
      },
      pending: { text: "Pending", role: "warning", icon: HourglassIcon },
      clientReview: {
        text: "Client Review",
        role: "warningLight",
        icon: HourglassIcon,
      },
      Expired: {
        text: "Expired",
        role: "warningLight",
        icon: TriangleExclamationIcon,
      },
      Probation: {
        text: "Probation",
        role: "error",
        icon: TriangleExclamationIcon,
      },
    },
  };
}

//From https://stackoverflow.com/a/71061690/751002
function toQueryString(obj) {
  return "?".concat(
    Object.keys(obj)
      .map((e) =>
        obj[e] ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}` : null
      )
      .filter((e) => !!e)
      .join("&")
  );
}

function getUrl(url, data) {
  return `${url}${toQueryString(data)}`;
}

export default function () {

  const params = new URLSearchParams(window.location.search);
  const ID = params.get("ID");
  const StatusID = params.get("status");


  const { data: miscFilterOptions } = useFetch(
    miscFilterOptionsUrl,
    "acceptCachedResponse"
  );
  const { data: allClientsData } = useFetch(
    allClientsUrl,
    "acceptCachedResponse"
  );
  const [allClients, setAllClients] = useState([]);
  const [urlParams, setUrlParams] = useSearchParams();
  const [clientId, setClientId] = useState(
    urlParams.get("clientId") || allClients?.[0]?.id
  );
  const [viewType, setViewType] = useState("grid");
  const [filterObj, setFilterObj] = useState({});
  const [pageCount, setPageCount] = useState(1);
  const [ClosePop, setClosePop] = useState(false);
  const [collection, setCollection] = useState({});
  const [Text, setText] = useState("");
  const [paramsState, setParamsState] = useState({
    clientId,
    vendorName: "",
    pageNumber: 1,
    pageSize: 12,
    statusIds: StatusID === "true" ? [16] : ""
  }); //change for client review navigation

  // const [paramsState, setParamsState] = useState(() => {
  //   const initialState = {
  //     clientId,
  //     vendorName: "",
  //     pageNumber: 1,
  //     pageSize: 12,
  //   };

  //   if (StatusID === "true"&& getOrgType()==="Client") {
  //     initialState.statusIds = [16];
  //   }

  //   return initialState;
  // });



  const [url, setUrl] = useState(
    //getUrl(queryUrl, { ...paramsState, pageSize, clientId })
    null
  );
  const { data: collectionData, loading, error } = useFetch(url);


  useLayoutEffect(() => {
    // if (clientId) {
    //   if (StatusID === "true" && getOrgType() === "Client") { // abdul change for client review navigation
    //     setUrl(getUrl(queryUrl, { ...paramsState, pageSize, statusIds: [16] }));
    //   } // abdul change for client review navigation
    //   else {
    //     setUrl(getUrl(queryUrl, { ...paramsState, pageSize }))
    //   }
    // }

    if (clientId)
      setUrl(getUrl(queryUrl, { ...paramsState, pageSize }));

  }, [paramsState]);

  useLayoutEffect(() => {
    if (collectionData) {
      setPageCount(Math.ceil((collectionData.count || pageSize) / pageSize));
      setCollection(
        vendorDataAdaptor ? vendorDataAdaptor(collectionData) : collectionData
      );
    }
  }, [collectionData]);

  useLayoutEffect(() => {
    // if (clientId) {
    //   if(getOrgType()!=="Client"){ // abdul change for client review navigation
    //   setUrlParams({ clientId });
    //   filterChangeHandler({});}
    // }
    // if(getOrgType()!=="Client"){ // abdul change for client review navigation
    // setParamsState({ clientId, vendorName: "", pageNumber: 1,statusIds : [16] });}

    if (clientId) {
      setUrlParams({ clientId });
      filterChangeHandler({});
    }
    setParamsState({ clientId, vendorName: "", pageNumber: 1, statusIds: StatusID === "true" ? [16] : "" }); //change for client review navigation

  }, [clientId]);
  useLayoutEffect(() => {
    if (allClients?.[0] && !clientId) {
      setParamsState({ clientId: allClients[0].id });
      setClientId(allClients[0].id);
    }
  }, [allClients]);

  useEffect(() => {
    setAllClients(
      (allClientsData?.data || []).map(({ text, value }) => ({
        id: value,
        text,
      }))
    );
  }, [allClientsData]);

  function filterChangeHandler(obj) {
    setFilterObj(obj);
    setUrl(getUrl(queryUrl, { ...paramsState, pageSize, ...obj, pageNumber: 1, vendorName: Text }));
    paramsState.pageNumber = 1;
  }

  function toggleViewType() {
    setViewType(viewType === "list" ? "grid" : "list");
  }

  function setSearchStr(str) {
    setText(str);
    setParamsState({ ...paramsState, ...filterObj, vendorName: str, pageNumber: 1 });
  }

  function setPage(pageNumber) {
    setParamsState((prev) => ({ ...paramsState, ...filterObj, pageNumber }));
  }
  const CloseTab = (val) => {
    setClosePop(val);
  }
  const [OpenAdvanceFilters, setOpenAdvanceFilters] = useState("");
  const OpenFilterTab = (val) => {
    setOpenAdvanceFilters(val);
  }
  return (
    <CollectionsTemplate
      title="Vendors"
      TitlebarChildren={VendorSearchTitleBarChildren}
      page={paramsState?.pageNumber}
      IsClientId={paramsState?.clientId} //Ony Balcklist functionality purpose
      setPage={setPage}
      pageCount={pageCount}
      fetchState={{ loading, error }}
      collection={collection}
      viewType={viewType}
      responseDataAdaptor={vendorDataAdaptor}
      ListItemComponent={VendorListItem}
      GridItemComponent={VendorGridItem}
      SlidingPopupTitle="Vendor Filters"
      ClosePopUp={ClosePop}
      SlidingPopupContent={
        <VendorFilters
          miscFilterOptions={miscFilterOptions?.data}
          optionsUrl={`${filterOptionsUrl}?clientId=${paramsState?.clientId}`}
          filterChangeHandler={filterChangeHandler}
          ClosePo={CloseTab}
          filterObj={filterObj}
          ID={OpenAdvanceFilters} //Open Advance Filters Tab
        />
      }
      CollectionControls={(props) => (
        <VendorCollectionControls
          allClients={allClients}
          setClientId={setClientId}
          ClosePo={CloseTab}
          clientId={paramsState?.clientId}
          setSearchStr={setSearchStr}
          searchStr={paramsState?.vendorName}
          toggleViewType={toggleViewType}
          viewType={viewType}
          searchPlaceholder="Search vendors"
          ID={ID} //Open Advance Filters Tab
          OpenFilterTab={OpenFilterTab}
          {...props}
        />
      )}
      filterObj={filterObj}
    />
  );
}
